import React, { useContext, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import '../styles/ContactForm.css';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import getRecaptchaToken from '../helpers/getRecaptchaToken';
import AppContext from './context/AppContext';

const invalidNameRegExp = /[^A-Za-z\-' ]/g;

const ContactForm = ({ }) => {
    const { appContext } = useContext(AppContext);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        if (!name || !email || !phone || !message)
            return;
        try {
            setIsSubmitting(true);
            const response = await fetch(
                new URL('/api/contactForm', process.env.APP_URL),
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({
                        name,
                        email,
                        phone,
                        message,
                        token: await getRecaptchaToken(appContext.config.recaptchaSiteKey),
                    }),
                }
            );
            const data = await response.json();
            setIsSubmitting(false);
            if (!response.ok || data.error)
                throw new Error(data.error ?? 'Something went wrong.');
            setSuccess(true);
            setName('');
            setEmail('');
            setPhone('');
            setMessage('');
        } catch (e) {
            setErrorMessage(e.message);
            console.error(e);
        }
    };
    useEffect(() => {
        let successTimer = null;
        const SUCCESS_TIMEOUT_MS = 3000;
        const successTimerFunc = () => setSuccess(false);
        if (success === true) {
            setTimeout(successTimerFunc, SUCCESS_TIMEOUT_MS);
        }
        return () => {
            clearTimeout(successTimer);
        };
    }, [success]);
    return (<div
        className={'contact-form-container'}>
        <h3>Send us a Message</h3>
        <p>We will get back to you as soon as possible.</p>
        <Form
            onSubmit={handleSubmit}>
            <Form.Group
                className={'mb-3'}
                controlId={'contactForm.name'}>
                <Form.Label>Name</Form.Label>
                <Form.Control
                    name={'formname'}
                    type={'text'}
                    placeholder={'Your name*'}
                    value={name}
                    disabled={isSubmitting}
                    onChange={(e) => setName(e.target.value)}
                    isValid={name.length > 0 && !name.match(invalidNameRegExp)}
                    isInvalid={name.match(invalidNameRegExp) !== null || name.length > 255}
                    required />
            </Form.Group>
            <Form.Group
                className={'mb-3'}
                controlId={'contactForm.email'}>
                <Form.Label>Email</Form.Label>
                <Form.Control
                    name={'formemail'}
                    type={'text'}
                    placeholder={'Email address*'}
                    value={email}
                    disabled={isSubmitting}
                    onChange={(e) => setEmail(e.target.value)}
                    isValid={isEmail(email)}
                    required />
            </Form.Group>
            <Form.Group
                className={'mb-3'}
                controlId={'contactForm.phone'}>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                    name={'formphone'}
                    type={'text'}
                    placeholder={'Phone number*'}
                    value={phone}
                    disabled={isSubmitting}
                    onChange={(e) => setPhone(e.target.value)}
                    isValid={isMobilePhone(phone, 'any')}
                    required />
            </Form.Group>
            <Form.Group
                className={'mb-3'}
                controlId={'contactForm.message'}>
                <Form.Label>Message</Form.Label>
                <Form.Control
                    as={'textarea'}
                    rows={3}
                    placeholder={'Your message*'}
                    value={message}
                    disabled={isSubmitting}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    isValid={message.length >= 3 && message.length <= 1500} />
            </Form.Group>
            <p>* Required fields</p>
            <Button
                className={'custom-btn'}
                type={'submit'}
                onClick={handleSubmit}
                disabled={(!name || !email || !message || isSubmitting)}>Send message</Button>
            {errorMessage !== '' && (<>
                <br />
                <p
                    style={{ color: 'red' }}>{errorMessage}</p>
            </>)}
            {success === true && (<>
                <br />
                <p
                    style={{ color: 'green' }}>Your message has been received. Thank you.</p>
            </>)}
        </Form>
    </div>);
};

export default ContactForm;